import { KeycloakAuth } from "@gportal/keycloak-auth";
import config from "../config";

export const auth = new KeycloakAuth(
  {
    autoRefresh: true,
    syncToken: true,
    ...config.keycloak,
  },
  true,
);
